<template>
  <ValidationObserver ref="organizationForm" v-slot="{ invalid, passes }">
    <v-skeleton-loader :loading="loading" :types="skeleton" type="article" class="mb-6">
      <v-form rel="organizationForm" @submit.prevent="passes(save)">
        <v-card class="elevation-1 mb-6 rounded-lg">
          <v-card-title class="pa-7">
            {{ title }}
          </v-card-title>
          <v-card-text class="pl-7 pr-7 pt-7">
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model="value.name"
                  rules="required"
                  outlined
                  dense
                  label="Název"
                  data-cy="name"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.type"
                  label="Typ"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="supplierProductTypes"
                  item-text="text"
                  item-value="name"
                  :loading="supplierProductTypeLoading"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.status"
                  label="Status"
                  rules="required"
                  outlined
                  dense
                  background-color="white"
                  :items="supplierProductStatuses"
                  item-text="text"
                  item-value="name"
                  :loading="supplierProductStatusLoading"
                />
              </v-col>
            </v-row>
            <v-row class="mb-1">
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Fixace</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.fixed"
                    :label="`${value.fixed ? 'Ano' : 'Ne'}`"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.contractType"
                  label="Typ smlouvy"
                  outlined
                  dense
                  background-color="white"
                  :items="contractTypes"
                  item-text="text"
                  item-value="name"
                  :loading="contractTypeLoading"
                  :clearable="true"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VTextFieldWithValidation
                  v-model.trim="value.contractPeriod"
                  label="Doba"
                  outlined
                  dense
                  background-color="white"
                />
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <VAutocompleteWithValidation
                  v-model.trim="value.contractPeriodUnit"
                  label="Jednotka"
                  outlined
                  dense
                  background-color="white"
                  :items="contractPeriodUnits"
                  item-text="text"
                  item-value="name"
                  :loading="contractPeriodUnitLoading"
                  :clearable="true"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Administrátor - zobrazení</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.adminEnabled"
                    :label="`${value.adminEnabled ? 'Zapnuto' : 'Vypnuto'}`"
                  ></v-checkbox>
                </div>
              </v-col>
              <v-col cols="12" sm="4" class="py-0 px-5">
                <div class="request-label">Zákazník - zobrazení</div>
                <div class="request-value mt-0">
                  <v-checkbox
                    v-model="value.clientEnabled"
                    :label="`${value.clientEnabled ? 'Zapnuto' : 'Vypnuto'}`"
                  ></v-checkbox>
                </div>
              </v-col>
            </v-row>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                type="submit"
                height="40px"
                min-width="130px"
                color="primary"
                depressed
                :loading="loading"
              >
                Uložit
              </v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-form>
    </v-skeleton-loader>
  </ValidationObserver>
</template>

<script>
import { mapActions } from 'vuex'
import VAutocompleteWithValidation from '../validators/VAutocompleteWithValidation'

export default {
  name: 'ProductForm',
  components: { VAutocompleteWithValidation },
  props: {
    value: {
      type: Object,
    },
    title: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
      required: true,
    },
  },
  data() {
    return {
      skeleton: {
        article: 'heading, paragraph@2',
      },
      supplierProductTypes: [],
      supplierProductStatuses: [],
      contractTypes: [],
      contractPeriodUnits: [],
      supplierProductTypeLoading: false,
      supplierProductStatusLoading: false,
      contractTypeLoading: false,
      contractPeriodUnitLoading: false,
    }
  },
  created() {
    this.loadSupplierProductType()
    this.loadSupplierProductStatus()
    this.loadContractType()
    this.loadContractPeriodUnit()
  },
  methods: {
    ...mapActions({
      getSupplierProductType: 'enum/listSupplierProductType',
      getSupplierProductStatus: 'enum/listSupplierProductStatus',
      getContractType: 'enum/listProductContractType',
      getContractPeriodUnit: 'enum/listProductContractPeriodUnit',
    }),
    loadSupplierProductType() {
      this.supplierProductTypeLoading = true
      this.getSupplierProductType()
        .then((response) => {
          this.supplierProductTypes = response.data
        })
        .finally(() => {
          this.supplierProductTypeLoading = false
        })
    },
    loadSupplierProductStatus() {
      this.supplierProductStatusLoading = true
      this.getSupplierProductStatus()
        .then((response) => {
          this.supplierProductStatuses = response.data
        })
        .finally(() => {
          this.supplierProductStatusLoading = false
        })
    },
    loadContractType() {
      this.contractTypeLoading = true
      this.getContractType()
        .then((response) => {
          this.contractTypes = response.data
        })
        .finally(() => {
          this.contractTypeLoading = false
        })
    },
    loadContractPeriodUnit() {
      this.contractPeriodUnitLoading = true
      this.getContractPeriodUnit()
        .then((response) => {
          this.contractPeriodUnits = response.data
        })
        .finally(() => {
          this.contractPeriodUnitLoading = false
        })
    },
    save() {
      this.$emit('save', this.value)
    },
  },
}
</script>
